<template>
  <div class="skippable-block">
    <!--    <CustomCheckBox @check="clickCheck" :name="prefixInput" :active="ces" label="Make skippable"/>-->
    <p>Make skippable</p>
    <div class="make-skippable">
      <ul class="make-skippable-ul text-p">
        <li :class="{'active-skip-item' :   0 === activeItem}" @click="selecteSkipTime(false, 0)" id="0">none</li>
        <li :class="{'active-skip-item' :   second.id === activeItem}" v-for="second in seconds" :id="second.id"
            @click="selecteSkipTime(second.s, second.id)">
          <span v-if="second.s !== 1">{{second.s}}s</span>
          <span v-if="second.s === 1">yes</span>
        </li>
      </ul>
<!--      <SocialInformationTooltip-->
<!--        v-if="item.name === 'Facebook' ||-->
<!--            item.name === 'YouTube' ||-->
<!--            item.name === 'Instagram'"-->
<!--        :text="item.name"-->
<!--        :social-color="item.name"/>-->
<!--      <SocialInformationTooltip-->
<!--        v-if="item.name === 'Twitter' || item.name === 'TikTok'"-->
<!--        :custom="true">-->
<!--        <div v-html="getInfoMessage(item.name)"></div>-->
<!--      </SocialInformationTooltip>-->
    </div>
  </div>

</template>
<script>
import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue";
import SocialInformationTooltip from "@/components/SocialInformationTooltip/SocialInformationTooltip.vue";
export default {
  name: 'Skippable',
  components: {
    CustomCheckBox, SocialInformationTooltip
  },
  data() {
    return {
      ces: false,
      activeItem: null,
      seconds: [
        {id: 1, s: 1},
        {id: 2, s: 10},
        {id: 3, s: 20},
        {id: 4, s: 30},
        {id: 5, s: 45}
      ]
    }
  },
  props: {
    prefixInput: String,
    activeCheckSkip: Boolean,
    item: Object,
  },
  methods: {
    clickCheck(payload) {
      this.ces = payload
      if (this.ces) {
        const {id, s} = this.seconds[0]
        this.selecteSkipTime(s, id)
      } else {
        this.activeItem = 0
        this.$props.item.check.skippable = this.ces
        this.selecteSkipTime(false, 0)
      }
    },
    selecteSkipTime(sec, idx) {
      if (idx === 0) {
        this.ces = false
      } else {
        this.ces = true
      }
      this.activeItem = idx
      this.$props.item.check.skippable = sec
      this.$emit('second', this.$props.item)
    },
    getInfoMessage(itemName) {
      if (itemName === 'Twitter') {
        return `
                <p>Please note that Twitter doesn’t allow actions such as Follow, Like, Reply, or Share to be mandatory
                for any gated content. </p>
                <p>To comply with this Twitter rule, your gate steps should be skippable. </p>
                <p>We recommend that you always combine a Twitter gate step with additional gate steps such as email
                capture. This ensures that you establish required connections each time a visitor unlocks your content -
                even if the Twitter step was skipped. </p>`;
      }
      if (itemName === 'TikTok') {
        return `
                <p>Please note that TikTok doesn’t allow actions such as Follow, Like, Comment, or Share to be mandatory
                for any gated content. </p>
                <p>To comply with this TikTok rule, your gate steps should be skippable. </p>
                <p>We recommend that you always combine a TikTok gate step with additional gate steps such as email
                capture. This ensures that you establish required connections each time a visitor unlocks your content
                - even if the TikTok step was skipped. </p>`;
      }
    }
  },
  created(){
    if(!this.$props.item.check.skippable){
      this.activeItem = 0
      this.$props.item.check.skippable = this.ces
      this.selecteSkipTime(false, 0)
    }else{
      let sid = this.seconds.find(item => item.s === this.$props.item.check.skippable).id
      const {id, s} = this.seconds[sid-1]
      this.selecteSkipTime(s, id)
    }

  }
}

</script>
<style lang="scss" scoped>;
.red {
  border: 1px solid red;
}
.skippable-block {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  background: #F9F9F9;
  border-bottom: none;
  p {
    color: $color-main-text;
    font-size: 14px;
    font-weight: 400;
  }
  .make-skippable {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .tooltip-block {
    margin: 0 0 0 10px;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
    .tooltip {
      height: 260px;
      width: 300px;
    }
  }
  .cntr {
    border: none;
    padding: 0;
    height: auto;
    background: transparent;
    label {
      padding: 0;
      span {
        font-size: 0.9em;
      }
    }
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    overflow: hidden;
    li {
      width: auto;
      padding: 0 10px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 30px;
      cursor: pointer;
      transition: 0.2s ease-in;
      background: #fff;
      @media (max-width: 768px) {
        font-size: 12px;
        padding: 0 8px;
      }
      &:first-child {
        &:hover {
          background: #C2C2C2;
          color: #fff;
        }
      }
      &:not(:last-child) {
        border-right: 1px solid #D9D9D9;
      }
      &:hover {
        background: $color-blue;
        color: #fff;
      }
    }
    .active-skip-item {
      background: $color-blue;
      color: #fff;
      &:first-child {
        background: #C2C2C2;
      }
    }
  }
}
</style>